module.exports = __webpack_public_path__ + "media/images/partners/4_lviv_academy-29cebbcdd5389be81efa68fbb8540526.png";